import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class EquipmentsService {
  public async addEquipment(equipmentModel: any) {
    let jsonBody = JSON.stringify(equipmentModel);
    try {
      let response = await fetch(`${BASE_URL}/equipments/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: jsonBody,
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }

  public async editEquipment(equipmentModel: any) {
    let jsonBody = JSON.stringify(equipmentModel);
    try {
      let response = await fetch(
        `${BASE_URL}/equipments/${equipmentModel._id}`,
        {
          method: "POST",
          headers: AuthUtils.getHeaders(),
          body: jsonBody,
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }

  public async deleteEquipment(equipmentModel: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/equipments/${equipmentModel._id}`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }

  public async deleteAllSelectedEquipments(selectedList: any) {
    try {
      let response = await fetch(
        `${BASE_URL}/equipments/delete/multiple`,
        {
          method: "DELETE",
          headers: AuthUtils.getHeaders(),
          body: JSON.stringify(selectedList),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }

  public async getEquipmentByCompanyId(companyId: String) {
    try {
      let response = await fetch(
        `${BASE_URL}/equipments/companies/${companyId}`,
        {
          method: "GET",
          headers: AuthUtils.getHeaders(),
          credentials: "include"
        }
      );
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
}
